import React, { useState } from 'react';
import ScrollContainer from '../../../../Base/Components/ScrollContainer';
import { useNCZIContext } from '../../../Services/NCZIContext';
import useNCZI from '../../../Hooks/useNCZI';
import apiClient from '../../../../../Services/ApiClient';
import { useEffectAsync } from '../../../../../helpers';
import NCZICommandResult from '../../NCZICommandResult/NCZICommandResult';
import EHRResult from '../../EHR/EHRResult/EHRResult';
import EHRExtract from '../../EHR/EHRExtract/EHRExtract';
import PatientConsentModal from '../../PatientConsentModal/PatientConsentModal';
import { PatientConsentType } from '../../../Commands/WritePatientConsent';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';

//@ts-ignore
import styles from './ElectronicHealthCardSummary.module.scss';

interface Props {
	setIsLoading: (isLoading: boolean) => void;
}

const ElectronicHealthCardSummary: React.FC<Props> = () => {
	const {
		patientIdentifier,
		patientSummaryData,
		setPatientSummaryData,
	} = useNCZIContext();
	const { fetchPatientSummaryData } = useNCZI();
	const [patientConsentModalOpened, setPatientConsentModalOpened] =
		useState<boolean>(false);
	const [loadingCommandId, setLoadingCommandId] = useState<string | undefined>(
		undefined,
	);

	const handleLoadPatientSummaryData = async () => {
		if (patientIdentifier) {
			const command = await fetchPatientSummaryData(patientIdentifier);
			if (command.id) {
				setLoadingCommandId(command.id);
			}
		}
	};

	const handleLoadData = async () => {
		if (!patientSummaryData) {
			// todo for test
			// const { data: response } = await apiClient.get(
			// 	'/nczi/message/48833ed1-561a-4b27-b5a6-9538666de816/response',
			// );
			// setPatientSummaryData(response.data);
			// todo for test

			await handleLoadPatientSummaryData();
		}
	};

	useEffectAsync(async () => {
		await handleLoadData();
	});

	const handleClosePatientPresenceConfirmation = async (
		needReload: boolean,
	) => {
		setPatientConsentModalOpened(false);
		if (needReload) {
			await handleLoadPatientSummaryData();
		}
	};

	const handleConfirmPatientPresence = async () => {
		setPatientConsentModalOpened(true);
	};

	if (!patientSummaryData || !patientIdentifier) {
		return (
			<div className={styles.wrapper}>
				<div className={styles.basicData}>
					<div className={styles.col}>
						<NCZICommandResult
							commandId={loadingCommandId}
							handleRetryCommand={handleLoadData}
						/>
					</div>
				</div>
			</div>
		);
	}

	const showPatientConfirmation =
		['W900001', 'E900002', 'E900001'].indexOf(
			patientSummaryData?.result?.code || '',
		) !== -1;

	return (
		<ScrollContainer className={styles.wrapper}>
			<EHRResult ehrResult={patientSummaryData?.result} />
			{showPatientConfirmation && (
				<LinkButton
					onClick={handleConfirmPatientPresence}
					title={'nczi.patientPresenceConfirmation.actionButton'}
					theme={Theme.BLUE}
				/>
			)}

			<EHRExtract ehrExtract={patientSummaryData?.ehrExtract} />

			<PatientConsentModal
				opened={patientConsentModalOpened}
				onClose={handleClosePatientPresenceConfirmation}
				patientIdentifier={patientIdentifier}
				consentType={PatientConsentType.PSU}
			/>
		</ScrollContainer>
	);
};

export default ElectronicHealthCardSummary;
